import React, { useState, useEffect } from 'react';
import i18n from 'i18n-js';
import PropTypes from 'prop-types';
import TaskContants from 'constants/tasks';
import { Autocomplete } from 'components/FormFields';
import { generateFilterOptions } from 'utils';

const PrioritySelect = ({
  label,
  variant,
  field: { name, value },
  margin,
  form: { errors, touched, setFieldValue },
}) => {
  const [defaultValue, setDefaultValue] = useState(null);
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = TaskContants.priorities.find((priority) => {
        return priority.value === value;
      });

      if (defaultVal) {
        setDefaultValue(defaultVal);
      } else {
        setDefaultValue(null);
      }
    }
  }, [value]) // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      id="priority"
      label={label}
      margin={margin}
      variant={variant}
      value={defaultValue}
      filterOptions={filterOptions}
      options={TaskContants.priorities}
      error={errors && errors[name] && touched && touched[name]}
      onChange={(ev, val) => setFieldValue(name, val?.value || '')}
      getOptionSelected={(option, value) => option.value === (value?.value || value) || ''}
      helperText={errors && errors[name] && touched && touched[name] && errors[name]}
      getOptionLabel={(option) => (option?.value ? i18n.t(`priorities.${option.value}`) : '')}
    />
  );
};

PrioritySelect.propTypes = {
  label: PropTypes.string,
  margin: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

PrioritySelect.defaultProps = {
  margin: 'none',
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  variant: 'standard',
  label: 'Status',
};

export default PrioritySelect;
